import React from "react";
import { cn } from "utils";
import { PortfolioItem } from "./PortfolioItem";
import type { PortfolioListProps } from "./types";

// 骨架屏 Item 组件
const SkeletonItem: React.FC = () => (
  <div className="w-full px-2 py-1 flex items-center gap-2">
    <div className="w-4 h-4 bg-background_white_overlay5 rounded animate-pulse" />
    <div className="flex-1 h-4 bg-background_white_overlay5 rounded animate-pulse" />
  </div>
);

export const PortfolioList: React.FC<PortfolioListProps> = ({
  data = [],
  mode = "select",
  onItemClick,
  onLockedClick,
  className,
  PortfolioListTitle,
  isLoading = false,
}) => {
  return (
    <div
      className={cn(
        "max-h-60 overflow-y-auto shrink-0 p-2 scrollbar",
        className,
      )}
    >
      {PortfolioListTitle && (
        <div className="pb-2 mx-2 sticky top-0 bg-background_solid_tertiary body_medium_m z-2">
          {PortfolioListTitle}
        </div>
      )}
      <div className="flex flex-col items-start">
        {isLoading ? (
          // 显示 4 个骨架屏占位
          <>
            <SkeletonItem />
            <SkeletonItem />
            <SkeletonItem />
            <SkeletonItem />
          </>
        ) : (
          data.map((item) => (
            <PortfolioItem
              data-openreplay-label="PortfolioContainer · PortfolioList · PortfolioItem"
              key={item.id}
              item={item}
              mode={mode}
              onClick={onItemClick}
              onLockedClick={onLockedClick}
            />
          ))
        )}
      </div>
    </div>
  );
};
